import { DefaultProjectRedirect } from '~/components/redirect/DefaultProjectRedirect';

export default function SettingsRedirect() {
  return <DefaultProjectRedirect targetPath="settings" />;
}
